import { createSelector } from 'reselect';
import { AppError } from 'src/redux/types';
export function notEmpty(value) {
  return value !== null && value !== undefined;
}
export const makeSelectCurrentItemData = createSelector([state => state.availableHeroInventoryResults.data, state => state.entities.skinConfig], (data, skinConfig) => {
  const reselectData = data.map(e => {
    if (!e) {
      return undefined;
    }

    const skinInfo = skinConfig === null || skinConfig === void 0 ? void 0 : skinConfig[e.skinId];
    return skinInfo ? { ...e,
      avatar: skinInfo.imageSmallAvatar,
      skinName: skinInfo.name
    } : undefined;
  });
  return reselectData.filter(notEmpty);
});
export const makeSelectCurrentTotalItems = state => state.availableHeroInventoryResults.totalItems || 0;
export const makeSelectCurrentItemLoading = state => state.availableHeroInventoryResults.loading;
export const makeSelectCurrentItemInvalidated = state => state.availableHeroInventoryResults.invalidated;
export const makeSelectCurrentItemError = state => state.availableHeroInventoryResults.error !== AppError.NO_ERROR;